import {
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Paper,
	Switch,
} from "@material-ui/core";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import numeral from "numeral";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import CompraProgramada from "./MetodosPagamento/CompraProgramada";
import UpdateField from "./Popover/UpdateField";

const MetodosPagamento = forwardRef((props, ref) => {
	const [selectPaymentMethod, SetSelectPaymentMethod] = useState([]);
	// const [selectPaymentMethoddesconto, SetSelectPaymentMethoddesconto] = useState([]);
	const [inputSelectd, setInputSelectd] = useState();
	const [metodoPagamentoAtivo, setMetodoPagamentoAtivo] = useState();
	const [metodoPagamentoSelecionado, setMetodoPagamentoSelecionado] =
		useState();
	const [popOverOpen, setPopOverOpen] = useState(null);
	const [valorParcelaAlterando, setValorParcelaAlterando] = useState(null);
	const [ancolaParcela, setAncoraParcela] = useState(null);

	useImperativeHandle(ref, () => ({
		updateCompraProgramada() {
			updateCompraProgramada();
		},
		updateMercadoPagoSemJuros(value) {
			updateMercadoPagoSemJuros(value);
		},
	}));

	const compraProgramadaError = (index) => {
		if (props.compraProgramada) {
			const lastChild = props.compraProgramada[index];
			return lastChild <= 0;
		}
		return true;
	};

	const addRemovePaymentMethod = (paymentMethodId) => {
		// console.log("paymentMethodId", paymentMethodId);
		const output = [];
		const selectPaymentMethodIds = [];
		// const selectPaymentMethoddescontos = [];
		let removed = false;
		props.paymentMethodsOpen.map((item) => {
			if (item.id !== paymentMethodId) {
				output.push(item);
				selectPaymentMethodIds.push(item.id);
			} else {
				removed = true;
			}
		});

		props.paymentMethods.map((item) => {
			if (item.id === paymentMethodId && !removed) {
				output.push(item);
				selectPaymentMethodIds.push(item.id);
			}
		});

		// props.paymentMethods.map((item, i) => {
		//     const value = selectPaymentMethoddescontos[i] !== 0 ? props.orcamentoResumo.porcentagemDeDesconto : selectPaymentMethoddescontos[i];
		//     selectPaymentMethoddescontos.push(value);
		// });

		SetSelectPaymentMethod(selectPaymentMethodIds);
		// SetSelectPaymentMethoddesconto(selectPaymentMethoddescontos);
		props.SetPagamentoMetodosOpen(output);
	};

	const calculaParcela = (type, totalParcelas, coeficiente, parcela, total) => {
		if (type === 1) {
			if (total) {
				return numeral(parcela * (totalParcelas * coeficiente)).format(
					"$ 0,0.00"
				);
			} else {
				return numeral(totalParcelas * coeficiente).format("$ 0,0.00");
			}
		} else if (type === 2) {
			if (total) {
				return numeral(totalParcelas * coeficiente * 10).format("$ 0,0.00");
			} else {
				return numeral((totalParcelas * coeficiente * 10) / parcela).format(
					"$ 0,0.00"
				);
			}
		}
	};

	const calcularCompraProgramada = () => {
		let parcelas = [];

		if (props.compraProgramada.length === 0) {
			for (let i = 1; i <= 12; i++) {
				parcelas.push((props.orcamentoResumo.totalParcelas / 12).toFixed(2));
			}
		}
		props.SetCompraProgramada(parcelas);

		if (parcelas.length > 0) {
			props.SetPagamentoMetodosSelecteds({
				...props.paymentMethodsSelecteds,
				7: {
					name: "Compra programada",
					installments: parcelas.length,
					value: 0,
				},
			});
		} else {
			const data = [];

			for (var key of Object.keys(props.paymentMethodsSelecteds)) {
				if (key !== "7") {
					data[key] = props.paymentMethodsSelecteds[key];
				}
			}
			props.SetPagamentoMetodosSelecteds(data);
		}
	};

	const SelectMercadoPagoSemJuros = () => {
		// console.log("PagamentoMetodos::SelectMercadoPagoSemJuros");
		// console.log(props.orcamentoResumo.totalParcelas);
		let parcelas = [];

		if (props.mercadoPagoSemJuros.length === 0) {
			for (let i = 1; i <= 12; i++) {
				parcelas.push((props.orcamentoResumo.totalParcelas / i).toFixed(2));
			}
		}
		props.setMercadoPagoSemJuros(parcelas);
	};

	const updateCompraProgramada = (index, value = null) => {
		let parcelas = [];

		const _value = value !== null ? value : props.compraProgramada[0];
		const compraProgramadaLength = props.compraProgramada.length;
		const others =
			(props.orcamentoResumo.totalParcelas - _value) /
			(compraProgramadaLength - 1);
		props.compraProgramada.map((item, i) => {
			if (i === 0) {
				parcelas.push(_value);
			} else {
				parcelas.push(others).toFixed(2);
			}
		});
		props.SetCompraProgramada(parcelas);
	};

	const updateMercadoPagoSemJuros = (value) => {
		// console.log("PagamentoMetodos::updateMercadoPagoSemJuros");
		let parcelas = [];

		const mercadoPagoSemJurosLength = props.mercadoPagoSemJuros.length;

		props.mercadoPagoSemJuros.map((item, i) => {
			parcelas.push((value / (i + 1)).toFixed(2));
		});
		props.setMercadoPagoSemJuros(parcelas);
	};

	const compraProgramadaSize = (quantidadeParcelas) => {
		let parcelas = [];
		for (let i = 1; i <= quantidadeParcelas; i++) {
			parcelas.push(
				(props.orcamentoResumo.totalParcelas / quantidadeParcelas).toFixed(2)
			);
		}
		props.SetCompraProgramada(parcelas);
	};

	const SetPagamentoMetodosSelecteds = (id, name, installments, value) => {
		// console.log("SetPagamentoMetodosSelecteds");
		// console.log(id, name, installments, value);

		if (
			props.paymentMethodsSelecteds[id] &&
			props.paymentMethodsSelecteds[id].name === name &&
			props.paymentMethodsSelecteds[id].installments === installments
		) {
			let data = [];
			for (var key of Object.keys(props.paymentMethodsSelecteds)) {
				if (name !== props.paymentMethodsSelecteds[key].name) {
					data.push(props.paymentMethodsSelecteds[key]);
				}
			}

			if (name === "Compra programada") {
				props.SetCompraProgramadaSelecionada(false);
			}

			props.SetPagamentoMetodosSelecteds(data);
		} else {
			if (id === 7) props.SetCompraProgramadaSelecionada(true);

			props.SetPagamentoMetodosSelecteds({
				...props.paymentMethodsSelecteds,
				[id]: {
					name: name,
					installments: installments,
					value: value,
				},
			});
		}
	};

	const mostaParcelas = (metodoPagamento, i) => {
		setMetodoPagamentoSelecionado(metodoPagamento);
		setMetodoPagamentoAtivo(i);
	};

	const ListaParcelas = () => {
		// console.log("ListaParcelas", metodoPagamentoSelecionado);
		if (metodoPagamentoSelecionado)
			return (
				<>
					<h4 className="metodoPagamentoSelecionadoTitulo">
						{metodoPagamentoSelecionado.nome}
					</h4>
					{metodoPagamentoSelecionado.slug !== "mp-sem-juros" &&
						metodoPagamentoSelecionado.slug !== "compra-programada" && (
							<ParcelasNormal />
						)}
					{metodoPagamentoSelecionado.slug === "mp-sem-juros" && (
						<ParcelasMpSemJuros />
					)}
					{metodoPagamentoSelecionado.slug === "compra-programada" && (
						<ParcelasCompraProgramada />
					)}
				</>
			);
		return <></>;
	};

	const alterarPrimeiraParcela = (event) => {
		setAncoraParcela(event.currentTarget);
		setValorParcelaAlterando(props.compraProgramada[0]);
		setPopOverOpen("alterarValorParcela");
	};

	const handleClose = () => {
		setAncoraParcela(null);
		setPopOverOpen(null);
	};

	const aplicarValorParcela = () => {
		setPopOverOpen(null);
		updateCompraProgramada(0, valorParcelaAlterando);
		setValorParcelaAlterando(null);
		setAncoraParcela(null);
	};

	const ParcelasCompraProgramada = () => {
		// console.log("props.compraProgramada", props.compraProgramada);

		return (
			<>
				<CompraProgramada
					orcamentoResumo={props.orcamentoResumo}
					compraProgramada={props.compraProgramada}
					setCompraProgramada={props.SetCompraProgramada}
					paymentMethodsSelecteds={props.paymentMethodsSelecteds}
					setCompraProgramadaSelecionada={props.SetCompraProgramadaSelecionada}
					SetPagamentoMetodosSelecteds={props.SetPagamentoMetodosSelecteds}
					updateCompraProgramada={updateCompraProgramada}
					compraProgramadaSelecionada={props.compraProgramadaSelecionada}
				/>
			</>
		);
	};

	const ParcelasMpSemJuros = () => {
		let parcelas = [];

		if (props.mercadoPagoSemJuros.length === 0) {
			for (let i = 1; i <= 21; i++) {
				parcelas.push((props.orcamentoResumo.totalParcelas / i).toFixed(2));
			}
		}

		return (
			<List component="nav">
				{parcelas.map((value, i) => {
					return (
						<ListItem
							key={i}
							button
							dense
							divider
							className={
								"item-parcela-lista " +
								(props.paymentMethodsSelecteds[metodoPagamentoSelecionado.id] &&
								props.paymentMethodsSelecteds[metodoPagamentoSelecionado.id]
									.installments ===
									i + 1
									? "menu-lista-metodos_pagamento_ativo"
									: "")
							}
							onClick={() =>
								SetPagamentoMetodosSelecteds(
									metodoPagamentoSelecionado.id,
									"Cartão de crédito",
									i + 1,
									numeral(parseFloat(value)).format("$ 0,0.00")
								)
							}
						>
							<ListItemIcon>
								<Switch
									color="default"
									edge="end"
									checked={
										props.paymentMethodsSelecteds[
											metodoPagamentoSelecionado.id
										] &&
										props.paymentMethodsSelecteds[metodoPagamentoSelecionado.id]
											.installments ===
											i + 1
									}
									inputProps={{
										"aria-labelledby": "switch-list-label-wifi",
									}}
								/>
							</ListItemIcon>
							<ListItemText
								primary={
									i +
									1 +
									"x de " +
									(inputSelectd === i
										? value
										: numeral(parseFloat(value)).format("$ 0,0.00")) +
									" - " +
									(inputSelectd === i
										? value
										: numeral(parseFloat(value * (i + 1))).format("$ 0,0.00"))
								}
							/>
						</ListItem>
					);
				})}
			</List>
		);
	};

	const ParcelasNormal = () => {
		return (
			<React.Fragment>
				<List component="nav">
					{props.paymentMethodsSelecteds &&
						metodoPagamentoSelecionado.coeficientes &&
						metodoPagamentoSelecionado.coeficientes.map((coefficient, i) => {
							return (
								<ListItem
									key={i}
									button
									dense
									divider
									className={
										"item-parcela-lista " +
										(props.paymentMethodsSelecteds[
											metodoPagamentoSelecionado.id
										] &&
										props.paymentMethodsSelecteds[metodoPagamentoSelecionado.id]
											.installments ===
											i + 1
											? "menu-lista-metodos_pagamento_ativo"
											: "")
									}
									onClick={() =>
										SetPagamentoMetodosSelecteds(
											metodoPagamentoSelecionado.id,
											metodoPagamentoSelecionado.nome,
											coefficient.ordem,
											calculaParcela(
												metodoPagamentoSelecionado.tipo_calculo_parcela,
												props.orcamentoResumo.totalParcelas,
												coefficient.coeficiente,
												parseInt(i + 1),
												false
											)
										)
									}
								>
									<ListItemIcon>
										<Switch
											color="default"
											edge="end"
											checked={
												props.paymentMethodsSelecteds[
													metodoPagamentoSelecionado.id
												] &&
												props.paymentMethodsSelecteds[
													metodoPagamentoSelecionado.id
												].installments ===
													i + 1
											}
											inputProps={{
												"aria-labelledby": "switch-list-label-wifi",
											}}
										/>
									</ListItemIcon>
									<ListItemText
										primary={
											coefficient.label +
											" de " +
											calculaParcela(
												metodoPagamentoSelecionado.tipo_calculo_parcela,
												props.orcamentoResumo.totalParcelas,
												coefficient.coeficiente,
												parseInt(i + 1),
												false
											) +
											" - " +
											calculaParcela(
												metodoPagamentoSelecionado.tipo_calculo_parcela,
												props.orcamentoResumo.totalParcelas,
												coefficient.coeficiente,
												parseInt(i + 1),
												true
											)
										}
									/>
								</ListItem>
							);
						})}
				</List>
			</React.Fragment>
		);
	};

	return (
		<div className="paymentMethods">
			<UpdateField
				elementId={"alterarValorParcela"}
				label={"Valor da primeira parcela"}
				popOverOpen={popOverOpen}
				anchorEl={ancolaParcela}
				handleClose={handleClose}
				valorAlterado={valorParcelaAlterando}
				setValorAlterando={setValorParcelaAlterando}
				atualizaPor={aplicarValorParcela}
			/>
			<Paper className="mt-2">
				{props.paymentMethods && props.orcamentoResumo.totalParcelas > 0 && (
					<>
						<div className="d-flex">
							<div className="menu-lista-metodos_pagamento">
								<List dense className="m-0 p-0">
									{props.paymentMethods.map((item, i) => {
										return (
											<div key={item.id}>
												<ListItem
													button
													onClick={() => mostaParcelas(item, i)}
													className={
														metodoPagamentoAtivo === i
															? "menu-lista-metodos_pagamento_ativo"
															: ""
													}
												>
													<ListItemText primary={item.nome} />
												</ListItem>
												<Divider />
											</div>
										);
									})}
								</List>
							</div>
							<div className="flexGrow-1">
								{!props.paymentMethods && <AutorenewIcon className="spin" />}
								<ListaParcelas />
							</div>
						</div>
					</>
				)}
			</Paper>
		</div>
	);
});

export default MetodosPagamento;
